module.exports = __webpack_public_path__ + "static/media/ki_background.bbf3ae81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/backgrounds/ki_background.png
// module id = 2522
// module chunks = 0